import React, { useMemo } from "react";

import FormattedValue from "@cayuse/shared-react.components.formatted-value";
import { generateId } from "@cayuse/shared-react.utils.helpers";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import Table from "components/Table";
import { getValueFromObjectByKeys } from "utils";

import styles from "./styles.css";


const FormSummaryTable = ({ activeColumnHeaders, formInstanceValues, numColumns = 3, isTabletView = false }) => {
	const columnHeadersByRow = useMemo(
		() => activeColumnHeaders.reduce((accumulator, colHeader, index) => {
			const isFirstCell = index % numColumns === 0;
			const currentRow = Math.floor(index / numColumns);

			if (isFirstCell) {
				accumulator.push([]);
			}

			if (colHeader.isPlaceholder) {
				colHeader.key = generateId("summary-placeholder-value");
			} else {
				colHeader.key = `summary-field-${colHeader.id || generateId("summary-field-")}`;
				colHeader.value = getValueFromObjectByKeys(formInstanceValues, colHeader.keys);
			}

			accumulator[currentRow].push(colHeader);

			return accumulator;
		}, []),
		[ activeColumnHeaders, formInstanceValues ],
	);

	if (!isNonEmptyArray(activeColumnHeaders)) {
		return "";
	}

	return (
		<div className={styles.scrollableTableWrapper}>
			{isTabletView ? (
				<ul className={styles.tabletViewListWrapper}>
					{columnHeadersByRow.map((rowCells, rowIndex) => (
						<li key={`summary-row-${rowIndex}`}>
							{rowCells.map(cell => (
								!cell.isPlaceholder && (
									<div key={cell.key} className={styles.summaryValueLayout}>
										<span className={`${styles.label} ${styles.tabletListLabel}`}>{cell.columnHeader}:</span>
										<FormattedValue
											type={cell.type}
											className={`${styles.value} ${styles.tabletListValue}`}
											value={cell.value}
											fallback="--"
										/>
									</div>
								)
							))}
						</li>
					))}
				</ul>
			) : (
				<Table noBorders captionText="Form Summary">
					<Table.Body>
						{columnHeadersByRow.map((rowCells, rowIndex) => (
							<Table.Row key={`summary-row-${rowIndex}`} >
								{rowCells.map(cell => (
									<Table.Cell key={cell.key}>
										{cell.isPlaceholder ? (
											<div />
										) : (
											<div className={styles.summaryValueLayout}>
												<span className={styles.label}>{cell.columnHeader}:</span>
												<FormattedValue
													type={cell.type}
													className={styles.value}
													value={cell.value}
													fallback="--"
												/>
											</div>
										)}
									</Table.Cell>
								))}
							</Table.Row>
						))}
					</Table.Body>
				</Table>
			)}
		</div>
	);
};

export default FormSummaryTable;
